var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message-delay-input" }, [
    _c("div", { staticClass: "delay-input-area" }, [
      _c("span", { staticClass: "material-icons delay-input-icon" }, [
        _vm._v("timer"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.mirrorValue,
            expression: "mirrorValue",
          },
        ],
        staticClass: "delay-input",
        attrs: { type: "text" },
        domProps: { value: _vm.mirrorValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.mirrorValue = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }